export const PRIVATE_ROLES = [
  'super_admin',
  'admin',
  'staff',
  'veterinarian',
  'receptionist',
  'warehouse',
  'viewer'
];

export const canManage = (role) => ['super_admin', 'admin'].includes(role);

export const canOperate = (role) => ['super_admin', 'admin', 'staff'].includes(role);

export const canViewReports = (role) => ['super_admin', 'admin', 'staff'].includes(role);
